import { useState, useRef, Fragment } from "react";
import Config from "../../Config";
import PlTitle from "../../elements/PlTitle";
import InputDate from "../../helpers/InputDate";
import InputPagger from "../../helpers/InputPagger";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import SortBy from "../../helpers/SortBy";
import MenuTable from "../../helpers/MenuTable";
import AppContext from "../../AppContext";
import Xlsx from "../../exporter/Xlsx";


function ReqPaySms(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [filterParam, setFilterParam] = useState({
 
        r_imie_nazwisko: props.mainView.readFilter('r_imie_nazwisko',''), 
   
 
        
        data_od: props.mainView.readFilter('data_od',''), 
        data_do: props.mainView.readFilter('data_do',''), 
    
        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },

     
        limit: 50,
        page: 1,
        pages: 1,

    });


    const [selectedRow, setSelectedRow] = useState([]);
    const [tab, setTab] = useState(null);
 

    const tabRef = useRef(0); //do druku
    const tab2Ref = useRef(0); //do druku



    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );



    const changeView = (e ) => {
        var v = e.target.getAttribute('v');
        var id = e.target.getAttribute('id');

        setView({...view, ["v"]:v, ["id"]:id });
    }


    const onBack = (e) => {

        setView({...view, ["v"]:"list", ["id"]:"-1" }); 
        getTab();
        
    }



   
    const getTab = () => {
            
        
        props.mainView.setProgress(-2);
    

        fetch( Config.url + '/rest_v1_calc,reqforpay_sms', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
        })
        .then(res => res.json() )
        .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);  
                        

                        var newSelector = [];

                        res.result.forEach( (item) => {
                            newSelector.push({
                                id: item.id,
                                title: item.to_email + " ("+item.rodzic.imie + " " + item.rodzic.nazwisko +")",
                                selected: 0,
                            });
                        } )

                        setSelectedRow(newSelector);
                       

                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
        } )
        .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
        });
                

        return false;
    }



    
    const valChangeListener = (filedName, val, correct, msg) => {

        // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }

        props.mainView.writeFilter(filedName, val);
    }


    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }




    const filterClear = () => {
 

        props.mainView.writeFilter('r_imie_nazwisko', ''); 
 
      

        props.mainView.writeFilter('data_od', ''); 
        props.mainView.writeFilter('data_do', ''); 
   

        setFilterParam({
      
            r_imie_nazwisko: '',
        
          

            data_od: '',
            data_do: '',

            sortBy: {
                sort:  "", //asc desc,
                column: "",
            },
                                       
            limit: 50,
            page: 1,
        });
        setTab(null);
    }

    const filterApprove = () => {   
        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }


    const onChangeSortBy = (sortBy) => {

        setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
        setTab(null);
    }




    const goSend = (e) => {


        var id = e.target.getAttribute('atr-id');
        var title = e.target.getAttribute('atr-title');
        var ids = new Array();

        var tome =  e.target.getAttribute('tome');
    
        if(tome == null || tome == undefined)
        {
            ids.push({
                id: id,
                title: title,
            });
        }else{
            ids.push({
                id: id,
                title: title,
                tome: '1',
            });
        }
    
       
    
    
     
 
        props.mainView.setProgress(-2);
    
        var req = {
            ids: ids,                            
        }

        fetch( Config.url + '/rest_v1_calc,reqforpay_send_sms', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
        })
        .then(res => res.json() )
        .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {   
                        if(res.status == "OK")       
                        {                                                  
                            props.mainView.showDialog( "Sukces!", "Wysłano pozycji: " + res.result , "ok" , null);  
                            getTab(); 
                        }
                    }
        } )
        .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
        });

    
    }

    const goSendMass = (e) => {

        var ids = new Array();
                
        for(var k=0; k<selectedRow.length; k++)
            {
               if( selectedRow[k].selected == 1)
               {
                    ids.push({
                        id: selectedRow[k].id,
                        title: selectedRow[k].title
                    });
               }
            }
        
    
         if(ids.length < 1)     
         {       
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnego dokumentu' ,  "ok"  ,null); 
            return;              
         }
    
    
      
     
 
        props.mainView.setProgress(-2);
    
        var req = {
            ids: ids,                            
        }

        fetch( Config.url + '/rest_v1_calc,reqforpay_send_sms', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
        })
        .then(res => res.json() )
        .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {   
                        if(res.status == "OK")       
                        {                                                  
                            props.mainView.showDialog( "Sukces!", "Wysłano pozycji: " + res.result , "ok" , null);  
                            getTab(); 
                        }
                    }
        } )
        .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
        });

    
    }



    const goDelMass = (e) => {

        var ids = new Array();
                
        for(var k=0; k<selectedRow.length; k++)
            {
               if( selectedRow[k].selected == 1)
               {
                    ids.push({
                        id: selectedRow[k].id,
                        title: selectedRow[k].title
                    });
               }
            }
        
    
         if(ids.length < 1)     
         {       
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnego dokumentu' ,  "ok"  ,null); 
            return;              
         }
    
    
      

         props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz usunać wybrane wezwania (szt. "+ids.length+") ", "yesno", (option)=>{
                          
            ///--------
            if(option == "yes")
            {

                            props.mainView.setProgress(-2);
                
                            var req = {
                                ids: ids,                            
                            }
                    
                            fetch( Config.url + '/rest_v1_calc,reqforpay_del', {
                                method: 'POST', 
                                body: JSON.stringify(req), 
                                headers: {
                                    'Content-Type': 'application/json',                    
                                    'X-Api-Key': props.userData.apiKey,
                                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                                    '_sec_key_': Config.genXKey() ,
                                }
                            })
                            .then(res => res.json() )
                            .then(res => { 
                    
                                        props.mainView.setProgress(-1);        
                                        if(res._sys_ == undefined)
                                        {
                                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                        }else
                                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                        {
                                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                        }else    
                                        {   
                                            if(res.status == "OK")       
                                            {                                                  
                                                props.mainView.showDialog( "Sukces!", "Usunięto pozycji: " + res.result , "ok" , null);  
                                                getTab(); 
                                            }
                                        }
                            } )
                            .catch(err => {          
                                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                        props.mainView.setProgress(-1);
                            });
            } 
        
        }
        );
 
 

    
    }



    const goGenerate = (e) => {
          
 
        props.mainView.setProgress(-2);
    
        var req = {
                                       
        }

        fetch( Config.url + '/rest_v1_calc,reqforpay_generate_sms', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
        })
        .then(res => res.json() )
        .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {   
                        if(res.status == "OK")       
                        {                                                  
                            props.mainView.showDialog( "Sukces!", "Utworzono pozycji: " + res.result , "ok" , null);  
                            getTab(); 
                        }
                    }
        } )
        .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
        });

    
    }

    //-------------------------------------------------------
//-------------------------------------------------------
//MASS
const changeSelected = (e) => {

    var id    = e.target.getAttribute('atr-id');   
    var selected = 0;

    if(e.target.checked) selected = 1;

    for(var k=0; k<selectedRow.length; k++)
    {
        if(selectedRow[k].id == id)  selectedRow[k].selected = selected;
    }

    setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) );    
}

const changeSelectedAll = (e) => {

    var s = selectedRow[0].selected;
    if(s == 1) {  s = 0; } else s = 1;

    for(var k=0; k<selectedRow.length; k++)
        {
          selectedRow[k].selected = s;
        }
    
        setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) ); 

}



//-------------------------------------------------------
//-------------------------------------------------------





    if(tab == null)
        {
            setTab([]);
            getTab();
        
    
            return <div>
                ...
            </div>
        }
    
    
        if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setTab(null);
            setView( {
                v:'list',
                id: -1
            });
        }






        var zaznaczonych = 0;
        for(var s=0; s<selectedRow.length; s++)
        {
            if(selectedRow[s].selected == 1) zaznaczonych ++;
        }



        var sortList = [                        
            {column: "created_at", name: "Data"  },        
            {column: "temat", name: "Temat"  },        
            {column: "rodzic_nazwisko", name: "Rodzic"  },
      
        ]



    var titleRaport = "Wezwania sms ";

    if(filterParam.r_imie_nazwisko.length > 3) titleRaport = titleRaport + ", rodzic: " +  filterParam.r_imie_nazwisko;
    if(filterParam.data_od.length > 3) titleRaport = titleRaport + ", od dnia: " +  filterParam.data_od;
    if(filterParam.data_do.length > 3) titleRaport = titleRaport + ", do dnia: " +  filterParam.data_do;

    document.title = titleRaport;      
    




    return <div className="view_content">

 

         
                <div className="bg_center">

                            <div className="table_filter">

                           

                                <div className="filter_controll">   
                                            <label>Rodzic: </label>                             
                                            <InputTextAlpha   userData={props.userData} value={filterParam.r_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="r_imie_nazwisko" placeholder={"Rodzic: "}   />
                                </div> 
            
                                            <div className="filter_controll filter_merge">   
                                                        <label>Data utworzenia (od dnia / do dnia): </label>      <br/>                       
                                                        <InputDate   userData={props.userData} value={filterParam.data_od}   valChange={valChangeListener} goNext={goNextNew} name="data_od" placeholder={"Od dnia: "}   />                                                                  
                                                        <InputDate   userData={props.userData} value={filterParam.data_do}   valChange={valChangeListener} goNext={goNextNew} name="data_do" placeholder={"Do dnia: "}   />
                                            </div> 


                                            <div className="filter_btn">
                                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                                            </div>
                            </div>


                            <div className="table_widget">

                                        <div className="btn" onClick={goGenerate} >Utwórz wg. zaległych</div>

                                        <InputPagger filter={filterParam}  onChange={onChangePagger}  />  


                                        <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title="Wezwania SMS" />   
                                        <Csv tabRef={tab2Ref} title="Wezwania SMS.csv" />                  
                                        <Xlsx tabRef={tab2Ref} title="Wezwania SMS.xlsx" />                  
                                        <Print tabRef={tab2Ref} />  

                                        <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />                                                                                                                       
                            </div>



                            
                            <div className="table_mass">  
                                    <div className="title_mass">Operacje masowe (zaznaczono: {zaznaczonych}) </div>                                                                 
                                    &nbsp;
                                    <span className="btn"  onClick={goSendMass} >Wyślij przez sms</span>       

                                    &nbsp;
                                    <span className="btn"  onClick={goDelMass} >Usuń zaznaczone</span>                            
                            </div>


                            <div className="gohide" ref={tabRef}>
                                <h3>{titleRaport}</h3>  

                                <table className="table" ref={tab2Ref} >
                                    <thead>
                                                        <tr className="header">    
                                                                                                                                                  
                                                            <td>LP</td>  
                                                            <td>Rodzic</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
                                                            <td>Numer odbiorcy</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
                                                            <td>Data utworzenia</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
                                                            <td>Powiązany dokument</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
                                                            <td>Treść</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
                                                            <td className="td_right">Wysłane do rodzica</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    
                                                        </tr>
                                    </thead>

                                    <tbody>
                                        {
                                            tab.map((row, ix) => {

 

                                                        var ww = "Tak";
                                                        if(row.wyslano == 0) ww = 'Nie';

                                                        var rowStyle = " row ";
                                                        if(ix % 2 == 0 )rowStyle = " row2 ";


                                                        return <tr className={rowStyle}>         
                                                                                                                                                     
                                                        <td className="gocenter">{ix+1}</td>  
                                                        <td>{row.rodzic.nazwisko + " " + row.rodzic.imie}</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
                                                        <td className="">{row.odbiorca}</td>                                                 
                                                        <td className="gocenter">{row.data}</td>                                                 
                                                        <td className="gocenter">
                                                            {
                                                               row.dokument != null  &&
                                                               <Fragment>
                                                                    {row.dokument.numer } <br/>{ row.dokument.kwota}
                                                               </Fragment>
                                                            }
                                                        </td>                                                 
                                                        <td className="gocenter">{row.tresc}</td> 
                                                        <td className="gocenter">{ww}</td>                                                               

                                                    </tr>  

                                            } )
                                        }
                                    </tbody>
                            </table>

                            </div>

                        <div className="scorll_x">
                            <table className="table" >
                                    <thead>
                                                        <tr className="header">    
                                                            <td className="link_normal td_left" onClick={changeSelectedAll}>Z</td>                                                                                                       
                                                            <td>LP</td>  
                                                            <td>Rodzic</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
                                                            <td>Numer odbiorcy</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
                                                            <td>Data utworzenia</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
                                                            <td>Powiązany dokument</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
                                                            <td>Treść</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
                                                            <td className="td_right">Wysłane do rodzica</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
                                                            <td className="td_option"> </td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
                                                            <td className="td_option"> </td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
                                                        </tr>
                                    </thead>

                                    <tbody>
                                        {
                                            tab.map((row, ix) => {


                                                        var isChecked = "";

                                                        for(var s=0; s<selectedRow.length; s++)
                                                            {
                                                                if( selectedRow[s].id == row.id &&  selectedRow[s].selected == 1) isChecked = "checked";
                                                            }

                                                        var ww = "Tak";
                                                        if(row.wyslano == 0) ww = 'Nie';

                                                        var rowStyle = " row ";
                                                        if(ix % 2 == 0 )rowStyle = " row2 ";


                                                        return <tr className={rowStyle}>         
                                                        <td className="gocenter">
                                                            <input type="checkbox" atr-id={row.id} onChange={changeSelected} checked={isChecked} />
                                                        </td>                                                                                                 
                                                        <td className="gocenter">{ix+1}</td>  
                                                        <td>{row.rodzic.nazwisko + " " + row.rodzic.imie}</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
                                                        <td className="">{row.odbiorca}</td>                                                 
                                                        <td className="gocenter">{row.data}</td>                                                 
                                                        <td className="gocenter">
                                                            {
                                                               row.dokument != null  &&
                                                               <Fragment>
                                                                    {row.dokument.numer } <br/>{ row.dokument.kwota}
                                                               </Fragment>
                                                            }
                                                        </td>                                                 
                                                        <td className="gocenter">{row.tresc}</td> 
                                                        <td className="gocenter">{ww}</td> 

                                                        <MenuTable>
                                                            <ul>
                                                                <li atr-id={row.id} atr-title={row.to_email}  onClick={goSend}  >wyślij</li>
                                                                <li atr-id={row.id} atr-title={row.to_email}  tome="1" onClick={goSend} >wyślij do mnie</li>
                                                            </ul>
                                                        </MenuTable>        

                                                        

                                                    </tr>  

                                            } )
                                        }
                                    </tbody>
                            </table>
                       </div>

                </div>



    </div>

    
}


export default ReqPaySms;